export const ADMIN_NAVIGATION_GUARD_EVENT = 'avwf:before-admin-navigation';

export type AdminNavigationGuardDetail = {
  resume?: () => void;
};

export const requestAdminNavigation = (resume?: () => void): boolean =>
  window.dispatchEvent(
    new CustomEvent<AdminNavigationGuardDetail>(ADMIN_NAVIGATION_GUARD_EVENT, {
      cancelable: true,
      detail: { resume }
    })
  );
